const { VUE_APP_CASH_DELIVERY_UI_BASE_URL, NODE_ENV } = process.env

const isProduction = NODE_ENV === 'production'

export const urls = [
  ...(!isProduction ? ['http://localhost:8081'] : []),
  VUE_APP_CASH_DELIVERY_UI_BASE_URL
]
